export default {
  operatorList: [],
  issuerList: [],
  tokenList: [],
};
